'use strict';

import { getTokenFromLocalStorage } from '@/utils/auth0Token';
import { API_BASEPATH_PORTAL } from '@/config/env.config.js';
import { portalApi } from './index.api';

/** POST /api/v1.0/study-builder — absolute URL so it is not tied to the portal client base path version. */
export function studyBuilderSubmitAbsoluteUrl() {
	const base = String(API_BASEPATH_PORTAL || '').replace(/\/?$/, '');
	if (!base) return '/api/v1.0/study-builder';
	const withoutV1 = base.replace(/\/api\/v1\/?$/, '');
	return `${withoutV1}/api/v1.0/study-builder`;
}

function newIdempotencyKey() {
	try {
		if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
	} catch {
		// ignore
	}
	return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Emails the submitter the study summary + indicative estimate (plain text).
 * POST /api/v1.0/study-builder — body: { toEmail, contact, plainTextBody }; optional Idempotency-Key header.
 *
 * Authorization is omitted unless the app considers the user logged in. Sending a stale/expired Bearer
 * token would make ASP.NET challenge Auth0 and return 401 before guest handling — so we never attach
 * Bearer unless we have a non-expired access token from the Auth0 cache (same source as the rest of the app).
 */
export const studyBuilderApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		sendStudyBuilderQuoteSummaryEmail: builder.mutation({
			query: (body) => {
				const token = getTokenFromLocalStorage();
				const headers = {
					'Idempotency-Key': newIdempotencyKey(),
				};
				if (token) {
					headers.authorization = `Bearer ${token}`;
				}
				const { toEmail, contact, plainTextBody } = body;
				return {
					url: studyBuilderSubmitAbsoluteUrl(),
					method: 'POST',
					headers,
					body: { toEmail, contact, plainTextBody },
				};
			},
		}),
	}),
});

export const { useSendStudyBuilderQuoteSummaryEmailMutation } = studyBuilderApi;
